
function sendEmail(ctx: string) {
    if (Q.Authorization.hasPermission("Role:Admin") || Q.Authorization.hasPermission("Role:Support")) {
        var dlgAdmin = new Nobox.Nobox.SendEmailAdminDialog();
        dlgAdmin.loadEntityAndOpenDialog(
            {
                Email: ctx
            } as Nobox.Nobox.CampaignresultRow);
    } else {
        var dlg = new Nobox.Nobox.SendEmailDialog();
        dlg.loadEntityAndOpenDialog(
            {
                Email: ctx
            } as Nobox.Nobox.CampaignresultRow);
    }
}
namespace Nobox {

    @Serenity.Decorators.registerFormatter()
    export class EmailFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (ctx.value == "" || ctx.value == null) {
                return "";
            } else {
                return `<span class="type-email"><a title="kirim email" href="javascript:;" onclick="sendEmail('${ctx.value}')"style="cursor:pointer; margin-right:3px;"><i class="fa fa-envelope text-blue"></i> ${ctx.value}</a></span>`;
            }
        }
    }
}